export default __webpack_public_path__ + "static/media/checklist1.6ea76fc9.png";